export default __webpack_public_path__ + "static/experienceImg4-80d38a2d5605b2616de355acfcf0b600.webp";